import { FormattedMessage } from 'react-intl';
import DocumentRequirement from '../DocumentRequirement/DocumentRequirement';
import messages from './RequirementTypes.messages';
import { TStatus } from '../NewDocUploads.types';

const ManagementAccounts = ({
    status,
    showStatus
}: {
    status: TStatus;
    showStatus: boolean;
}) => {
    return (
        <DocumentRequirement
            title={
                <FormattedMessage
                    {...messages.ManagementAccountsTitle}
                    values={{ strong: (chunks) => <strong>{chunks}</strong> }}
                />
            }
            documentType="management accounts"
            status={status}
            showStatus={showStatus}
        >
            <p>
                <FormattedMessage {...messages.ManagementAccountsInfo} />
            </p>
        </DocumentRequirement>
    );
};

// eslint-disable-next-line import/no-default-export
export default ManagementAccounts;
